<template>
  <a-spin :spinning="loading" wrapper-class-name="spin-directory-tree">
    <div
      v-if="autoCollapse"
      class="h-[calc(100vh_-_168px)] cursor-pointer bg-white"
      :class="collapseTree ? 'tree-water-supply-area-slide-in' : 'tree-water-supply-area-slide-out'"
      @mouseleave="handleMouseLeave"
      @mouseenter="handleMouseEnter"
      @mousemove="handleMouseMove"
    >
      <div v-show="!collapseTree" class="flex justify-end p-3">
        <div class="cursor-pointer">
          <a-tooltip>
            <template #title>
              {{ title }}
            </template>
            <double-right-outlined />
          </a-tooltip>
        </div>
      </div>
      <transition name="fade">
        <div v-if="collapseTree" :class="`w-[${width}px]`">
          <a-directory-tree v-bind="$attrs" />
        </div>
        <div v-else class="w-full flex-1 bg-red-500" />
      </transition>
    </div>
    <a-directory-tree v-else v-bind="$attrs" />
  </a-spin>
</template>

<script lang="ts">
export default {
  name: 'CDirectoryTree',
}
</script>

<script lang="ts" setup>
import debounce from 'lodash/debounce.js'
import { ref } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'

defineProps({
  title: {
    type: String,
    default: 'Default Title',
  },
  loading: {
    type: Boolean,
    default: false,
  },
  autoCollapse: {
    type: Boolean,
    default: false,
  },
  width: {
    type: Number,
    default: 300,
  },
})

const collapseTree = ref(true)
let mouseTimer = null

const handleCollapseTree = (val, seconds = 600) => {
  const debouncedFunction = debounce(value => {
    collapseTree.value = value
  }, seconds)

  debouncedFunction(val)
}

const handleMouseEnter = () => {
  clearTimeout(mouseTimer)
}

const handleMouseLeave = () => {
  clearTimeout(mouseTimer)
  handleCollapseTree(false, 600)
}

const handleMouseMove = () => {
  clearTimeout(mouseTimer)
  mouseTimer = setTimeout(() => {
    handleCollapseTree(true)
  }, 100)
}
</script>

<style lang="scss" scoped>
.tree-water-supply-area-slide-out {
  transform: translateX(calc(-100% + 39px));
  transition: all 0.4s ease-in-out;
}

.tree-water-supply-area-slide-in {
  transform: translateX(0);
  transition: all 0.4s ease-in-out;
}

.arrow-slide-out {
  transition: all 0.4s ease-in-out;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<style lang="scss">
.spin-directory-tree {
  position: relative;
  background: white;
  .ant-spin-container {
    position: sticky;
    top: 0;
    bottom: 0;
  }
}
</style>
